<div class="pl-11px pt-12px pb-11px">
  <div class="centered-vert hov-cursor-p ml-7px" (click)="expanded = !expanded">
    <span class="ink-10-v3 fs-11px fw-600 tt-uppercase">{{ label | localize }}</span>
    <span class="ink-10-v3 ml-5px fw-600">
      <span class="gh-font-icon-arrow-down-small" *ngIf="expanded"></span>
      <span class="gh-font-icon-arrow-right-small" *ngIf="!expanded"></span>
    </span>
  </div>
  <div class="mt-7px" *ngIf="expanded">
    <sub-nav-options [options]="options"></sub-nav-options>
  </div>
</div>
